export default "__VITE_ASSET__DlI_$pma__"